import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import RenderHTML from "react-native-render-html";
import CollapsibleView from "@components/molecules/CollapsibleView";

type ShippingInformationProps = {
  title: string;
  description: string;
};

const ShippingInformation = ({
  title,
  description,
}: ShippingInformationProps) => {
  const { theme, typography, t } = useScreenOptionsHooks();

  return (
    <CollapsibleView
      initExpanded={true}
      title={title}
      arrowStyling={{ color: theme["core-04"] }}
      applyShadow
      applyTopPadding={false}
      applyBottomPadding={false}
    >
      <Divider />
      <Container>
        <RenderHTML
          source={{ html: t(description) }}
          tagsStyles={{
            body: typography["Minor-R"],
            b: {
              ...typography["Minor-M"],
            },
          }}
        />
      </Container>
    </CollapsibleView>
  );
};

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
  max-width: 100%;
`;

const Container = styled.View`
  padding-vertical: ${SpaceType.Basic}px;
  padding-horizontal: ${SpaceType.Double}px;
`;

export default ShippingInformation;
